<template>
  <div>
    <component v-bind:is="tool"></component>
  </div>
</template>

<script>
import ScaleAnatomy from "@/interact/ScaleAnatomy.vue";

export default {
  name: 'Tools',
  components: {
    ScaleAnatomy,
  },
  data() {
    return {
      tool: null
    }
  },
  mounted () {
    this.setTool();
  },
  methods: {
    setTool() {
      switch (this.id) {
      case 'scaleanatmony':
        //console.log('setting... ', this.id)
        this.tool = 'ScaleAnatomy';
        break;
    
      default:
        break;
    };
    }
  },
  computed: {
    id() {
      return this.$route.params.id
    }
  },
}
</script>

<style lang="scss" scoped>

</style>
